const config = {
    apiUrl: process.env.REACT_APP_API_URL as string,
} as const;

if (!config.apiUrl) {
    throw new Error("REACT_APP_API_URL is not defined. Check your .env file.");
}

export default config;